import { atom } from "recoil";
import { ocPersistAtom } from "./persist-atom";

export const ocCurrentVersionState = atom({
  key: "ocCurrentVersionState",
  default: "",
  effects_UNSTABLE: [ocPersistAtom],
});
